import React, { useContext, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { includes } from 'lodash';
import TypeSelector from '../components/TypeSelector';
import menuContext from '../contexts/menu';
import useQueryString from '../../hooks/useQueryString';
import { FILTER } from '../constants';

export default () => {
  const { search } = useLocation();
  const history = useHistory();
  const { type: selectedType, filter: selectedFilter } = useQueryString();
  const { menuCache } = useContext(menuContext);
  const { displayTypes } = menuCache || {};

  useEffect(() => {
    if (includes([FILTER.BESTSELLER, FILTER.FRESH, FILTER.DRINKS], selectedFilter)) {
      const url = new URLSearchParams(search);
      url.delete('type');
      const newSearch = `?${url.toString()}`;

      if (search !== newSearch) {
        history.push({ search: newSearch });
      }
    }
  }, [selectedFilter, history, search]);

  const setSelectedType = (value) => {
    const url = new URLSearchParams(search);

    if (value) url.set('type', value);
    else url.delete('type');

    const newSearch = url.toString();

    history.push({ search: `?${newSearch}` });
  };

  return includes([FILTER.BESTSELLER, FILTER.FRESH, FILTER.DRINKS], selectedFilter)
    ? null : (
      <TypeSelector
        selectedType={selectedType}
        setSelectedType={setSelectedType}
        types={displayTypes}
      />
    );
};
